import styled from 'styled-components'

// import theme from 'configs/theme'

const Styled = styled.div``

export default Styled
